import SectionHeading from "./SectionHeading";
import { characters } from "@/mocks/movieData";

export default function CastSection() {
  return (
    <section id="cast" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="Characters"
          title="人物群像：关系如何推动剧情"
          desc="理解人物在故事里的位置，往往比记住剧情细节更能读懂整部剧。以下按人物在叙事中承担的功能做梳理。"
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {characters.map((person) => (
            <article
              key={person.name}
              className="group rounded-xl overflow-hidden bg-background-100 border border-background-200 hover:border-primary-300 transition-colors"
            >
              <div className="relative w-full aspect-[3/4]">
                <img
                  src={person.img}
                  alt={`《嫂子的诱惑》人物群像之${person.name}`}
                  className="w-full h-full object-cover object-top"
                />
                <span className="absolute top-3 left-3 px-2 py-1 rounded-md bg-foreground-950/70 text-background-50 text-xs backdrop-blur">
                  {person.tag}
                </span>
              </div>
              <div className="p-4">
                <div className="flex items-center justify-between gap-2">
                  <h3 className="text-base font-semibold text-foreground-950">{person.name}</h3>
                  <span className="text-xs text-primary-600 font-label">{person.role}</span>
                </div>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{person.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}